<template>
  <div class="content_con">
    <div class="navs">
      <div class="navs_top">
        <div class="navs_top_name">
          <span>{{ tabList.eng }}</span>
          <div class="top_tab" v-if="tabList.tabUp">
            <ul>
              <li
                :class="cloumnIdd == t.id ? 'active' : ''"
                v-for="(t, index) in tabList.tabUp"
                :key="index"
                @click="navClick(t, index)"
              >
                {{ t.name }}
              </li>
            </ul>
          </div>
          <span v-else><i></i><i></i></span>
        </div>
        <div class="line"></div>
        <div class="navs_top_name">
          <span>{{ tabList.name }}</span>
          <div class="top_tab">
            <ul>
              <li
                :class="cloumnIdd == t.id ? 'active' : ''"
                v-for="(t, index) in tabList.tab"
                :key="index"
                @click="navClick(t, index)"
              >
                {{ t.name }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="t.name"
                  placement="top-start"
                >
                  {{ t.name }}
                </el-tooltip>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="nav">
        <div class="nav_left">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
              :to="{ path: '/' }"
              style="color: #c2c4ce; font-size: 1.125rem; cursor: pointer"
              >{{ $t('home') }}</el-breadcrumb-item
            >
            <template v-for="(t, index) in list">
              <el-breadcrumb-item
                v-if="t.tab === leftTab"
                :key="index"
                style="color: #c2c4ce; font-size: 1.125rem; cursor: pointer"
                @click="toList(t)"
                ><span>{{ t.name }}</span></el-breadcrumb-item
              >
            </template>

            <el-breadcrumb-item
              ><span
                :style="{
                  fontSize: '1.125rem',
                  cursor: 'pointer',
                  color: detailName == '' && '#606266',
                  fontWeight: detailName != '' ? 'normal' : 'bold',
                }"
                @click="toPage(cloumnPath)"
                >{{ cloumnName }}</span
              ></el-breadcrumb-item
            >
            <el-breadcrumb-item
              v-if="detailName != ''"
              style="color: #424451; font-size: 1.125rem; cursor: pointer"
              ><a style="cursor: pointer">{{
                detailName
              }}</a></el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div>
      <div
        class="main_content wow slideInLeft"
        data-wow-duration="0.3s"
        data-wow-offset="10"
        :style="ys"
      >
        <slot name="main_content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { navList } from '../const';
import responsiveMixin from '../mixins/responsiveMixin';
import { isHttpLink } from '@/utils';

export default {
  mixins: [responsiveMixin],
  name: 'contentList',
  props: {
    tabList: { type: Object, default: {} },
    currentIndex: { type: Number, default: 0 },
    leftTab: {
      type: Number,
      default: 0,
    },
    cloumnId: {
      type: String,
      default: '',
    },
    ys: {
      type: Object,
      default: function () {
        return {};
      },
    },
    detailName: { type: String, default: '' },
  },
  data() {
    return {
      cloumnIdd: this.cloumnId,
      cloumnName: '',
      cloumnPath: '',
      list: navList,
      style1: { color: '#c2c4ce', fontSize: '1.125rem', cursor: 'pointer' },
    };
  },

  mounted() {
    if (this.$route.query && this.$route.query.cloumnId) {
      this.cloumnIdd = this.$route.query.cloumnId;
    }
    this.tabList.tab.map((t) => {
      if (t.id == this.cloumnIdd) {
        this.cloumnName = t.name;
        this.cloumnPath = t.accessPath;
      }
    });
    this.tabList.tabUp &&
      this.tabList.tabUp.map((t) => {
        if (t.id == this.cloumnIdd) {
          this.cloumnName = t.name;
          this.cloumnPath = t.accessPath;
        }
      });
  },
  methods: {
    navClick(v, i) {
      this.cloumnIdd = v.id;
      this.cloumnName = v.name;
      if (isHttpLink(v.accessPath)) {
        window.location.href = v.accessPath;
      } else {
        this.$router.push({
          path: v.accessPath,
          query: { cloumnId: this.cloumnIdd },
        });
      }

      // this.$emit('tabChagnge', v, this.cloumnIdd);
      // document.documentElement.scrollTop = 0;
    },
    toList(v) {
      v.subnav.map((s) => {
        if (v.accessPath == s.accessPath) {
          this.cloumnIdd = s.id;
          this.cloumnName = s.name;
          this.$router.push({
            path: v.accessPath,
            query: { cloumnId: this.cloumnIdd },
          });
        }
      });
    },
    toPage(path) {
      this.$router.push({
        path: path,
        query: { cloumnId: this.cloumnIdd },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 1400px) {
  .top_tab ul li {
    font-size: 1.3rem !important;
    padding: 0 1rem !important;
  }
}
.navs {
  .navs_top {
    padding: 3.125rem 6.25% 0;
    width: 100%;
    height: 260px;
    box-sizing: border-box;
    background: #fff;

    .navs_top_name {
      display: flex;
      align-items: center;
      // 用 flex-start，让右侧用 margin-left 自动推过去
      // justify-content: flex-start;
      justify-content: space-between; // 左右两边对齐
      height: 5.125rem;
      line-height: 5.125rem;
      // 左边大标题
      > span {
        flex-shrink: 0; // 不会被无限压缩到 0
        max-width: 25%; // 最多占 25% 宽度
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 2.5rem;
        font-family: SourceHanSansCN-Medium;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-right: 2rem;

        i {
          display: inline-block;
          width: 0.625rem;
          height: 0.625rem;
          background: #c2c4ce;
          margin-left: 0.75rem;
        }
      }

      .top_tab {
        // flex: 1 1 auto; // 右边占剩余空间，可压缩
        // min-width: 0; // 允许被压缩
        overflow: hidden;

        ul {
          display: flex;
          flex-wrap: nowrap; // 永远不换行
          overflow: hidden;

          li {
            flex: 0 1 auto; // 根据内容自适应，可压缩
            min-width: 0;
            height: 3.6875rem;
            line-height: 3.6875rem;
            margin-left: 2rem;
            // display: flex;
            // align-items: center;
            // justify-content: center;
            padding: 0 2rem;
            background: #f0f1f2;
            border-radius: 50px;
            font-size: 1.5rem;
            cursor: pointer;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            &:hover,
            &.active {
              background: #6b6d7a;
              color: #fff;
              overflow: visible;
              text-overflow: clip;
              flex: 0 0 auto; // 不再压缩，宽度由内容撑开
              max-width: none; // 允许自动放大
              z-index: 2; // 避免被其他 li 遮挡
              transition: all 0.3s;
            }

            &:first-child {
              margin-left: 0;
            }

            // 内部的 span 文字再做 ellipsis
            .ellipsis {
              display: block;
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
            }
          }
        }
      }
    }

    .line {
      width: 100%;
      background: #dadbdf;
      height: 1px;
    }
  }

  .nav {
    width: 62.5%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    font-size: 1.125rem;
    .nav_left {
      flex: 6;
      margin-top: 1.5rem;
    }
  }
}

.main_content {
  width: 62.5%;
  margin: 0 auto;
}

::v-deep .el-breadcrumb__item {
  .el-breadcrumb__inner {
    &.is-link {
      font-weight: normal;
      color: #666;
    }
  }

  .el-breadcrumb__inner {
    a {
      color: #333;
      font-weight: bold;
      &:hover {
        color: #333;
        font-weight: bold;
      }
    }
    &:hover {
      color: #666;
    }
  }
}

.main_content {
  width: 62.5%;
  margin: 0 auto;
}

::v-deep .el-breadcrumb__item {
  .el-breadcrumb__inner {
    &.is-link {
      font-weight: normal;
      color: #666;
    }
  }

  .el-breadcrumb__inner {
    a {
      color: #333;
      font-weight: bold;
      &:hover {
        color: #333;
        font-weight: bold;
      }
    }
    &:hover {
      color: #666;
    }
  }
}
</style>
